import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import SystemLog from '@/components/system-event-logs/models/SystemLog'

@Module({
  name: 'DevToolsModule',
  namespaced: true,
  store: store,
  dynamic: true
})
class DevToolsModule extends VuexModule {
  logIfBigThan = 999
  maxTipCount = 100
  receiveCount = 0
  systemLogs: Array<SystemLog> = new Array<SystemLog>()

  @Action
  addSystemLog(systemLog: SystemLog) {
    this.DO_ADD_SYSTEM_LOG(systemLog)
  }

  @Action
  clearReceiveCount() {
    this.CLEAR_RECEIVE_COUNT()
  }

  @Mutation
  DO_ADD_SYSTEM_LOG(systemLog: SystemLog) {
    this.systemLogs.push(systemLog)
    this.receiveCount++
  }

  @Mutation
  CLEAR_RECEIVE_COUNT() {
    this.receiveCount = 0
  }
}

export default getModule(DevToolsModule)
